import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import {
  DxActionSheetModule,
  DxButtonModule,
  DxDataGridModule,
  DxDraggableModule,
  DxDropDownButtonModule,
  DxFormModule,
  DxPopoverModule,
  DxSwitchModule,
  DxTagBoxModule,
  DxTextBoxModule,
  DxToolbarModule
} from "devextreme-angular";
import { PageDetailHeaderActionComponent } from "./page-detail/page-detail-header-action.component";
import { PageDetailHeaderTagBoxComponent } from "./page-detail/page-detail-header-tag-box.component";
import { PageDetailHeaderComponent } from "./page-detail/page-detail-header.component";
import { PageDetailImageComponent } from "./page-detail/page-detail-image.component";
import { PageDetailTabComponent } from "./page-detail/page-detail-tab.component";
import { PageDetailComponent } from "./page-detail/page-detail.component";
import { PageDatagridComponent } from "./page-datagrid/page-datagrid.component";
import { PageDatagridColumnComponent } from "./page-datagrid/page-datagrid-column.component";
import { PageDatagridColumnButtonComponent } from "./page-datagrid/page-datagrid-column-button.component";
import { PageDatagridToolbarComponent } from "./page-datagrid/page-datagrid-toolbar.component";
import { PageDatagridToolbarActionComponent } from "./page-datagrid/page-datagrid-toolbar-action.component";
import { PageDatagridColumnCelltemplateDirective } from "./page-datagrid/page-datagrid-column-celltemplate.directive";
import { PageEditComponent } from "./page-edit/page-edit.component";
import { TranslocoModule } from "@jsverse/transloco";
import { PageGenericComponent } from "./page-generic/page-generic.component";
import { PageGenericActionComponent } from "./page-generic/page-generic-action.component";
import { PageCardComponent } from "./page-card/page-card.component";
import { PageCardItemComponent } from "./page-card/page-card-item.component";
import { PageCardActionComponent } from "./page-card/page-card-action.component";
import { AvatarNominativeModule } from "../avatar-nominative/avatar-nominative.module";
import { PageCardItemLineComponent } from "./page-card/page-card-item-line.component";
import { PageCardItemActionComponent } from "./page-card/page-card-item-action.component";
import { PageCardItemDescription } from "./page-card/page-card-item-description.component";
import { PageCardItemTitleDescription } from "./page-card/page-card-item-title-description.component";
import { PageDataGridEditComponent } from "./page-datagrid/page-datagrid-edit.component";
import { PageEditActionComponent } from "./page-edit/page-edit-action.component";
import { PageDatagridColumnIconComponent } from "./page-datagrid/page-datagrid-column-icon.component";
import { PageCardItemContentComponent } from "./page-card/page-card-item-content.component";
import { ButtonModule } from "../button/button.module";
import { PageDetailHeaderLinkComponent } from "./page-detail/page-detail-header-link.component";
import { RouterModule } from "@angular/router";
import { PageDetailHeaderBadgeComponent } from "./page-detail/page-detail-header-badge.component";
import { PageDetailHeaderEmojiComponent } from "./page-detail/page-detail-header-emoji.component";
import { EmojiModule } from "../emoji/emoji.module";
import { PageCardSearchComponent } from "./page-card/page-card-search.component";
import { TextBoxModule } from "../textbox/textbox.module";
import { PageGenericSearchComponent } from "./page-generic/page-generic-search.component";
import { PageDetailHeaderLine } from "./page-detail/page-detail-header-line.component";
import { DirectivesModule } from "src/app/modules/bootstrap/directives/directives.module";
import { PageGenericActionSeparatorComponent } from "./page-generic/page-generic-action-separator.component";
import { PageDetailWidgetDirective } from "./page-detail/page-detail-widget.directive";
import { PageGenericToolbarCustomItemDirective } from "./page-generic/page-generic-toolbar-custom-item.directive";
import { PageDetailTagComponent } from "./page-detail/page-detail-tag.component";
import { PageDetailHeaderIconComponent } from "./page-detail/page-detail-header-icon.component";
import { ActionsModule } from "src/app/components/ui/actions/actions.module";
import { PageEditStatusContentDirective } from "src/app/components/ui/page/page-edit/page-edit-status-content.directive";
import { NotifyNewContentModule } from "src/app/components/ui/notify-new-content/notify-new-content.module";
import { PageToolbarComponent } from "src/app/components/ui/page/page-shared/page-toolbar/page-toolbar.component";
import { PageToolbarSwitchComponent } from "src/app/components/ui/page/page-shared/page-toolbar/items/page-toolbar-switch.component";
import { PageToolbarItemComponent } from "src/app/components/ui/page/page-shared/page-toolbar/page-toolbar-item.component";
import { PageToolbarDividerComponent } from "src/app/components/ui/page/page-shared/page-toolbar/items/page-toolbar-divider.component";
import { PageToolbarCardComponent } from "src/app/components/ui/page/page-shared/page-toolbar/items/page-toolbar-card.component";
import { PageToolbarCustomComponent } from "src/app/components/ui/page/page-shared/page-toolbar/items/page-toolbar-custom.component";
import { PageToolbarActionComponent } from "src/app/components/ui/page/page-shared/page-toolbar/items/page-toolbar-action.component";
import { PageToolbarActionGroupComponent } from "src/app/components/ui/page/page-shared/page-toolbar/items/page-toolbar-action-group.component";
import { PipesModule } from "src/app/pipes/pipes.module";
import { PageToolbarDateRangeComponent } from "src/app/components/ui/page/page-shared/page-toolbar/items/page-toolbar-daterange.component";
import { DaterangePickerModule } from "src/app/components/ui/daterange-picker/daterange-picker.module";
import { PageToolbarGroupComponent } from "src/app/components/ui/page/page-shared/page-toolbar/items/page-toolbar-group.component";
import { PageGenericToolbarComponent } from "src/app/components/ui/page/page-generic/page-generic-toolbar/page-generic-toolbar.component";
import { EditableModule } from "src/app/components/ui/editable/editable.module";
import { ExecuteActionInstallationFunctionModule } from "src/app/modules/bootstrap/functions/installations/execute-action-installation/execute-action-installation-function.module";
import { PageDetailContentComponent } from "src/app/components/ui/page/page-detail/page-detail-content.component";
import { TagModule } from "src/app/components/ui/tag/tag.module";
import { PageDatagridToolbarSelectComponent } from "src/app/components/ui/page/page-datagrid/page-datagrid-toolbar-select.component";
import { PageDatagridToolbarTextComponent } from "src/app/components/ui/page/page-datagrid/page-datagrid-toolbar-text.component";

@NgModule({
  imports: [
    CommonModule,

    RouterModule,

    TranslocoModule,

    DxButtonModule,
    DxTagBoxModule,
    DxToolbarModule,
    DxDataGridModule,
    DxFormModule,
    DxDropDownButtonModule,
    DxDraggableModule,
    DxTextBoxModule,
    DxPopoverModule,
    DxSwitchModule,
    DxActionSheetModule,

    PipesModule,
    AvatarNominativeModule,
    ButtonModule,
    TextBoxModule,
    EmojiModule,
    DirectivesModule,
    ActionsModule,
    NotifyNewContentModule,
    DaterangePickerModule,
    EditableModule,
    TagModule,

    ExecuteActionInstallationFunctionModule
  ],
  declarations: [
    PageGenericComponent,
    PageGenericToolbarComponent,
    PageGenericActionComponent,
    PageGenericSearchComponent,
    PageGenericActionSeparatorComponent,
    PageGenericToolbarCustomItemDirective,

    PageDetailComponent,
    PageDetailImageComponent,
    PageDetailHeaderComponent,
    PageDetailHeaderLine,
    PageDetailHeaderLinkComponent,
    PageDetailHeaderActionComponent,
    PageDetailHeaderBadgeComponent,
    PageDetailHeaderEmojiComponent,
    PageDetailHeaderTagBoxComponent,
    PageDetailContentComponent,
    PageDetailTabComponent,
    PageDetailWidgetDirective,
    PageDetailTagComponent,
    PageDetailHeaderIconComponent,

    PageDatagridComponent,
    PageDatagridColumnComponent,
    PageDatagridColumnButtonComponent,
    PageDatagridColumnIconComponent,
    PageDatagridToolbarComponent,
    PageDatagridToolbarActionComponent,
    PageDatagridToolbarSelectComponent,
    PageDatagridToolbarTextComponent,
    PageDatagridColumnCelltemplateDirective,
    PageDataGridEditComponent,
    PageEditComponent,
    PageEditActionComponent,
    PageEditStatusContentDirective,
    PageCardComponent,
    PageCardSearchComponent,
    PageCardItemComponent,
    PageCardActionComponent,
    PageCardItemLineComponent,
    PageCardItemActionComponent,
    PageCardItemTitleDescription,
    PageCardItemDescription,
    PageCardItemContentComponent,

    PageToolbarComponent,
    PageToolbarItemComponent,
    PageToolbarSwitchComponent,
    PageToolbarDividerComponent,
    PageToolbarCardComponent,
    PageToolbarCustomComponent,
    PageToolbarGroupComponent,
    PageToolbarActionGroupComponent,
    PageToolbarActionComponent,
    PageToolbarDateRangeComponent
  ],
  exports: [
    PageGenericComponent,
    PageGenericActionComponent,
    PageGenericSearchComponent,
    PageGenericActionSeparatorComponent,
    PageGenericToolbarCustomItemDirective,
    PageDetailComponent,
    PageDetailImageComponent,
    PageDetailHeaderComponent,
    PageDetailHeaderLine,
    PageDetailHeaderLinkComponent,
    PageDetailHeaderActionComponent,
    PageDetailHeaderTagBoxComponent,
    PageDetailHeaderBadgeComponent,
    PageDetailHeaderEmojiComponent,
    PageDetailContentComponent,
    PageDetailTabComponent,
    PageDetailWidgetDirective,
    PageDetailTagComponent,
    PageDetailHeaderIconComponent,
    PageDatagridComponent,
    PageDatagridColumnComponent,
    PageDatagridColumnButtonComponent,
    PageDatagridColumnIconComponent,
    PageDatagridToolbarComponent,
    PageDatagridToolbarActionComponent,
    PageDatagridToolbarSelectComponent,
    PageDatagridToolbarTextComponent,
    PageDatagridColumnCelltemplateDirective,
    PageDataGridEditComponent,
    PageEditComponent,
    PageEditActionComponent,
    PageEditStatusContentDirective,
    PageCardComponent,
    PageCardSearchComponent,
    PageCardItemComponent,
    PageCardActionComponent,
    PageCardItemLineComponent,
    PageCardItemActionComponent,
    PageCardItemTitleDescription,
    PageCardItemDescription,
    PageCardItemContentComponent,

    PageToolbarComponent,
    PageToolbarItemComponent,
    PageToolbarSwitchComponent,
    PageToolbarDividerComponent,
    PageToolbarCardComponent,
    PageToolbarCustomComponent,
    PageToolbarGroupComponent,
    PageToolbarActionGroupComponent,
    PageToolbarActionComponent,
    PageToolbarDateRangeComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PageModule {}
